<div class="user-exceed-limits">
  <p>
    ¡Ups!, no pudimos continuar con el registro de tus datos. ¡Te puedes
    comunicar con nosotros por nuestro WhatsApp de Servicio al Client -
    3192510001 o en cualquiera de nuestras líneas de atención! ¡Nos vemos
    pronto!
  </p>
</div>
